import App from './src/App'
import 'react-native-gesture-handler';
import "react-native-get-random-values";


export default App